import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from "./types";

const initial_state = [];

const notificationsReducer = (state = initial_state, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return [
        ...state,
        {
          type: action.notification_type,
          message: action.message,
          id: action.id
        }
      ];
    case REMOVE_NOTIFICATION:
      return state.filter(notification => notification.id !== action.id);
    default:
      return state;
  }
};

export default notificationsReducer;
